import { ComponentProps, ReactNode } from 'react';
import { cn } from '../../../utils/cn';
import { FaIcon } from '../../icon/fa-icon';
import { Inline } from '../../inline/inline';
import { Stack } from '../../stack/stack';
import { Avatar } from '../avatar/avatar';

type FaIconConfig =
  | {
      isFaIcon: false;
    }
  | {
      isFaIcon: true;
      faIconName: string;
    };

type AvatarNameDescriptionProps = {
  avatar:
    | {
        showAvatar: false;
      }
    | {
        showAvatar: true;
        avatarUrl?: string | null;
        size?: ComponentProps<typeof Avatar>['size'];
        faIcon?: FaIconConfig;
      };
  name: string;
  description?: string | null;
  descriptionIcon?: ReactNode;
  className?: string;
};

export const AvatarNameDescription = ({
  avatar,
  name,
  description,
  descriptionIcon,
  className,
}: AvatarNameDescriptionProps) => {
  return (
    <div className={className}>
      <Inline space={3} align={'center'} className="h-full w-full">
        <AvatarWrapper avatar={avatar} name={name} />

        <Stack space={1} className="min-w-0 flex-1">
          <p className="w-full truncate text-start text-sm leading-6 font-normal tracking-tight text-black">{name}</p>

          {description && (
            <Inline space={1} wrap="nowrap" className="w-full">
              {descriptionIcon}

              <p
                className={cn(
                  'w-full truncate text-start text-xs leading-6 font-normal tracking-tight text-muted-foreground',
                )}
              >
                {description}
              </p>
            </Inline>
          )}
        </Stack>
      </Inline>
    </div>
  );
};

const AvatarWrapper = ({
  avatar,
  name,
}: {
  avatar: AvatarNameDescriptionProps['avatar'];
  name: AvatarNameDescriptionProps['name'];
}) => {
  if (!avatar.showAvatar) {
    return null;
  }

  if (avatar.faIcon?.isFaIcon) {
    return <FaIcon iconName={avatar.faIcon.faIconName} />;
  }

  return <Avatar avatarUrl={avatar.avatarUrl} name={name} size={avatar.size} />;
};
